import './App.css';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Navigation from "./template/Navigation";
import Footer from "./template/Footer";

import Home from './scenes/home/Home';
import Search from './scenes/search/Search';
import AdvancedSearch from './scenes/search/AdvancedSearch'
import Persons from './scenes/persons/Persons';
import Works from './scenes/works/Works';
import Places from './scenes/places/Places';

import About from './scenes/info/about/About';
import Instructions from './scenes/info/instructions/Instructions';
import Contacts from './scenes/info/contacts/Contacts';


import PersonPage from './scenes/person_page/PersonPage';
import WorkPage from './scenes/work_page/WorkPage';
import PlacePage from './scenes/place_page/PlacePage';

function App() {
  return (
    <div className="App">
      <Router>
        <Navigation />
        <Switch>
          <Route path="/" exact component={() => <Home />} />
          <Route path="/search" exact component={() => <Search />} />
          <Route path="/search/advanced" exact component={() => <AdvancedSearch />} />
          <Route path="/works" exact component={() => <Works />} />
          <Route path="/persons" exact component={() => <Persons />} />
          <Route path="/places" exact component={() => <Places />} />
          <Route path="/info/about" exact component={() => <About />} />
          <Route path="/info/instructions" exact component={() => <Instructions />} />
          <Route path="/info/contacts" exact component={() => <Contacts />} />

          <Route path="/person/:id" exact component={() => <PersonPage />} />
          <Route path="/work/:id" exact component={() => <WorkPage />} />
          <Route path="/place/:id" exact component={() => <PlacePage />} />
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
